var map = {
	"./pallet-10.svg": 66058,
	"./pallet-100.svg": 78285,
	"./pallet-1on8.svg": 66617,
	"./pallet-20.svg": 31069,
	"./pallet-30.svg": 81013,
	"./pallet-40.svg": 40893,
	"./pallet-5.svg": 91919,
	"./pallet-50.svg": 39345,
	"./pallet-60.svg": 85127,
	"./pallet-70.svg": 43168,
	"./pallet-7on8.svg": 38954,
	"./pallet-80.svg": 44949,
	"./pallet-90.svg": 96180,
	"./pallet-empty.svg": 71877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55592;